import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
import get from "lodash/get";

import UploadFile from "../UploadFile";
import CustomButton from "../CustomButton";

const _ = { get };

function imageSection(props) {
  let { elements, value } = props;
  return (
    <React.Fragment>
      <Modal
        className="modalcenter"
        size="xl"
        isOpen={value.toggleUploadImageSection}
      >
        <ModalHeader toggle={props.handleUploadImageSection}>
        
          {_.get(
            elements,
            "joinWebUserListing.rejectionElement",
            "Upload Images"
          )}
        </ModalHeader>
        <ModalBody>
          <Row>
            {value.image.map((item) => (
              <Col lg={3}>
                <UploadFile value={item} />
                {/* <UploadFile
                  value={item}
                  id="image1"
                  image={state.image}
                  uploadedImage={state.aboutUsLogo}
                  handleImageChange={handleImageChange}
                  deleteImage={deleteImage}
                /> */}
              </Col>
            ))}
          </Row>
        </ModalBody>
        <ModalFooter>
          <CustomButton
            customType={"submit"}
            name={_.get(
              elements,
              "joinWebUserListing.rejectionButtonElement",
              "Add"
            )}
            customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
            // customClick={(e) => this.handleDisApproveUser(e)}
          />
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}
export default imageSection;
